import { type ReactNode } from 'react';
import { TABLE_ROW_MEASURE_HEIGHT } from '@/features/shared/components/tableSystem/tableConstants';
import {
  TableCellContainer as SharedTableCellContainer,
  type TableCellContainerGap,
} from '@/ui/composites/table';
import type { SxProps, Theme } from '@/ui/primitives';

type TableCellContainerProps = {
  children: ReactNode;
  gap: TableCellContainerGap;
  pt?: string;
  sx?: SxProps<Theme>;
};

export const TableCellContainer = ({
  children,
  gap,
  pt,
  sx,
}: TableCellContainerProps): JSX.Element => (
  <SharedTableCellContainer
    gap={gap}
    sx={[
      {
        height: '100%',
        minHeight: `${TABLE_ROW_MEASURE_HEIGHT}px`,
        justifyContent: 'flex-start',
        pb: '10px',
      },
      pt !== undefined ? { pt } : null,
      ...(sx ? (Array.isArray(sx) ? sx : [sx]) : []),
    ]}
  >
    {children}
  </SharedTableCellContainer>
);
